<section fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap.gt-xs="16px">
  <ng-template [appHasPermission]="TUFT_LINK_PERMISSION">
    <app-texedit-card-external-application
      appDataCy="tuft-link"
      fxFlex="376px"
      fxFlex.lt-sm="auto"
      iconForCard="tuft-blue"
      titleForCard="TEXEDIT_CARDS.EXTERNAL_APPLICATIONS.TUFTLINK.TITLE"
      applicationName="tuftlink"
      [applicationDownloadUrl]="tuftLinkDownloadUrl"
    ></app-texedit-card-external-application>
  </ng-template>
</section>
